import styled from '@emotion/styled'
import { size } from '@styles/theme'

const FollowsYouContainer = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;

  padding: ${size(0.25)} ${size(0.5)};
  border: 1px solid rgba(255,255,255, 0.15);
  border-radius: 5px;
  
  font-size: 0.55rem;
  font-weight: 700;
  
  background-color: #333333;
  color: grey;
`

const FollowsYouIndicator = ({ isFollowingYou=false }) => {
  if (!isFollowingYou) return;
  return (
    <FollowsYouContainer>
      FOLLOWS YOU
    </FollowsYouContainer>
  )
}

export { FollowsYouIndicator }
